/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface PostUsersCurrentMembershipModifyPreviewRequest {

    user_id?: number;

    product_id?: number;

    annual?: boolean;

    gateway_name?: string;

    gateway_data?: string;

    discount_code?: string;

    offer_set_uuid?: string;

    offer_uuid?: string;

    price?: number;

    period?: string;

    level_id?: number;

}

@Model('PostUsersCurrentMembershipModifyPreview')
export class ApiPostUsersCurrentMembershipModifyPreview extends BaseModel implements PostUsersCurrentMembershipModifyPreviewRequest {

    
    
    user_id: number;

    
    
    product_id: number;

    
    
    annual: boolean;

    
    
    gateway_name: string;

    
    
    gateway_data: string;

    
    
    discount_code: string;

    
    
    offer_set_uuid: string;

    
    
    offer_uuid: string;

    
    
    price: number;

    
    
    period: string;

    
    
    level_id: number;

}
